import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getAdminPracticeTillages, getPracticeTillages } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE_TIME, GET_PRACTICES_TILLAGES } from "consts";

import { PracticeTillage, WithInjectedName } from "models";

export const useGetPracticeTillages = ({ enabled }: { enabled?: boolean }) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("practices", { useSuspense: false });
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getAdminPracticeTillages : getPracticeTillages;

  return useQuery<Array<WithInjectedName<PracticeTillage>>>({
    queryKey: [GET_PRACTICES_TILLAGES, enabled, isAdmin],
    queryFn: async () => {
      const tillages = await queryFn({ enabled });
      return tillages.map((til) => ({ ...til, name: t(`tillages.${til.translationSlug}`) }));
    },
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
